const central = 'Central'
const execSupt = 'Executive Superintendent'
const superintendent = 'Superintendent'
const fieldStaff = 'Field Staff'

const principal = 'Principal'
const assistantPrincipal = 'Assistant Principal'

const schoolBasedStaff = 'School Based Staff'

const teacher = 'Teacher'


function viewsLandingPage (role) {
    return [central, execSupt, superintendent, fieldStaff].indexOf(role) !== -1
}

function viewsAdminDashboard (role) {
    return [principal, assistantPrincipal, schoolBasedStaff].indexOf(role) !== -1
}

export {
    central,
    execSupt,
    superintendent,
    fieldStaff,
    principal,
    assistantPrincipal,
    schoolBasedStaff,
    teacher,
    viewsLandingPage,
    viewsAdminDashboard
}